import Vue from 'vue';
import Vuex from 'vuex';
import auth from './store/user';
import group from './store/group';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth, group
	},
	strict: false,
});